/**
 * Service pour la gestion des membres d'clients
 */
import api from './api';
import type {
  ClientMember,
  ClientMemberCreate,
  ClientMemberUpdate,
  MemberRole,
} from '../types/client';

export interface BuyerMembersListParams {
  client_id?: number;
  role?: MemberRole;
  is_active?: boolean;
  skip?: number;
  limit?: number;
}

class BuyerMembersService {
  private baseUrl = '/clients/me/members';

  /**
   * Liste les membres d'clients
   */
  async list(params?: BuyerMembersListParams): Promise<ClientMember[]> {
    const response = await api.get<ClientMember[]>(this.baseUrl, { params });
    return response.data;
  }

  /**
   * Récupère un membre par son ID
   */
  async getById(id: number): Promise<ClientMember> {
    const response = await api.get<ClientMember>(`${this.baseUrl}/${id}`);
    return response.data;
  }

  /**
   * Crée un nouveau membre
   */
  async create(data: ClientMemberCreate): Promise<ClientMember> {
    const response = await api.post<ClientMember>(this.baseUrl, data);
    return response.data;
  }

  /**
   * Met à jour un membre
   */
  async update(id: number, data: ClientMemberUpdate): Promise<ClientMember> {
    const response = await api.patch<ClientMember>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  /**
   * Supprime un membre
   */
  async delete(id: number): Promise<void> {
    await api.delete(`${this.baseUrl}/${id}`);
  }

  /**
   * Liste les membres d'un client spécifique
   */
  async listByBuyer(clientId: number): Promise<ClientMember[]> {
    return this.list({ client_id: clientId });
  }
}

export default new BuyerMembersService();
